export const REDIRECT_BASE_URL: string = process.env
  .REDIRECT_BASE_URL as string;
export const VIVA_BASE_URL: string = process.env.REACT_APP_API_URL as string;
export const VIVA_AUTH_URL: string = process.env.REACT_APP_AUTH_URL as string;
export const VIVA_AUTH_REALM: string = process.env
  .REACT_APP_AUTH_REALM as string;
export const VIVA_AUTH_CLIENTID: string = process.env
  .REACT_APP_AUTH_CLIENTID as string;
